import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  Button,
  Flex,
  List,
  Spin,
  Input,
  Popover,
  Modal,
  Slider,
} from "antd";
import {
  CheckOutlined,
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
  FormOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import {
  useDeleteChecklistMutation,
  useFetchChecklistsByTypeQuery,
  useFetchHotholdChecklistStatusQuery,
  useReorderTasksMutation,
  useUpdateChecklistMutation,
  useUpdateHotholdChecklistStatusMutation,
} from "../opencheck/checklists.service";
import { useFetchSensorLatestTempByRestaurantQuery } from "../temperatures/temperature.service";
import { useFetchSensorListQuery } from "../home/home.service";
import { SocketIOContext } from "../../provider/socketprovider";
import { useTranslation } from "react-i18next";
import "./style.css";
import { toast } from "react-toastify";
import ChecklistTaskNote from "../../components/ChecklistTaskNote";

const Hotholdchecklist = () => {
  const { t, i18n } = useTranslation();

  const curLanguage = i18n.language;

  const [sensorTemps, setSensorTemps] = useState({});

  const { sensorTemperatures, connectSocket, socket, disconnectSocket } =
    useContext(SocketIOContext);

  useEffect(() => {
    if (!socket) connectSocket();
    return () => {
      disconnectSocket();
    };
  }, []);

  useEffect(() => {
    setSensorTemps((e) => ({ ...e, ...sensorTemperatures }));
  }, [sensorTemperatures]);

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalId, setIsModalId] = useState();
  const [modalContent, setModalContent] = useState();
  const [contents, setContents] = useState({});
  const [checkTempSlider, setCheckTempSlider] = useState({});
  const [openPopoverId, setOpenPopoverId] = useState(null);

  const { data: sensorlist } = useFetchSensorListQuery();
  const {
    data = [],
    isFetching,
    isSuccess,
  } = useFetchChecklistsByTypeQuery("hothold", {
    refetchOnMountOrArgChange: true,
  });
  const { data: latestTemp = [], isSuccess: isFetchLatestTempSuccess } =
    useFetchSensorLatestTempByRestaurantQuery();
  const { data: hotholdChecklistStatusData = {} } =
    useFetchHotholdChecklistStatusQuery();
  const [deleteChecklist, { isLoading: isDeleteLoading }] =
    useDeleteChecklistMutation();
  const [requestUpdateCheckList] = useUpdateChecklistMutation();
  const [reorderTasks] = useReorderTasksMutation();
  const [updateOpenChecklistStatus] = useUpdateHotholdChecklistStatusMutation();
  const handleDeleteChecklist = async (id) => {
    try {
      await deleteChecklist(id);
    } catch (error) {
      console.log("Failed to delete checklist");
    }
  };

  const handleCompleteChecklist = (data) => {
    requestUpdateCheckList(data);
  };

  const handleReorderTask = (orderTask, type) => {
    if (type === "up" && orderTask.taskNumber !== 1) {
      const tmpTaskUp = data.find(
        (item) => item.taskNumber === orderTask.taskNumber - 1
      );
      if (tmpTaskUp) {
        const tmpDataUp = data.reduce((arr, cur) => {
          if (tmpTaskUp._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber + 1 });
            return arr;
          }
          if (orderTask._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber - 1 });
            return arr;
          }
          arr.push({ id: cur._id, taskNumber: cur.taskNumber });
          return arr;
        }, []);
        reorderTasks({ tasks: tmpDataUp });
      }
    }
    if (
      type === "down" &&
      data.filter((item) => item.taskNumber > orderTask.taskNumber).length > 0
    ) {
      const tmpTaskDown = data.find(
        (item) => item.taskNumber === orderTask.taskNumber + 1
      );
      if (tmpTaskDown) {
        const tmpDataDown = data.reduce((arr, cur) => {
          if (tmpTaskDown._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber - 1 });
            return arr;
          }
          if (orderTask._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber + 1 });
            return arr;
          }
          arr.push({ id: cur._id, taskNumber: cur.taskNumber });
          return arr;
        }, []);
        reorderTasks({ tasks: tmpDataDown });
      }
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      setIsModalId();
      setModalContent();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isFetchLatestTempSuccess)
      setSensorTemps(
        latestTemp.reduce((obj, cur) => {
          obj[cur.dev_eui] = cur.temperature;
          return obj;
        }, {})
      );
  }, [isFetchLatestTempSuccess]);

  useEffect(() => {
    if (isSuccess) {
      setCheckTempSlider((prev) => {
        const next = { ...prev };
        data.forEach((cur) => {
          if (prev[cur._id] === undefined || prev[cur._id] === null) {
            next[cur._id] = cur.tempSlider;
          } else if (
            cur.status === "completed" &&
            cur.tempSlider !== undefined &&
            cur.tempSlider !== null &&
            Number(cur.tempSlider) !== 0
          ) {
            next[cur._id] = cur.tempSlider;
          }
        });
        return next;
      });
    }
  }, [data]);

  return (
    <Card
      title={t("PROBE CHECKLIST")}
      className="opencheck-list-page"
      bordered={false}
      extra={
        <Flex justify="center">
          <Button style={{ margin: "0 10px" }}>{t("CANCEL")}</Button>
          <Button style={{ margin: "0 10px" }} type="primary">
            {t("Save")}
          </Button>
          <Button
            onClick={() => navigate("/provechecks/create")}
            type="primary"
          >
            {t("Create")}
          </Button>
        </Flex>
      }
    >
      <Spin spinning={isFetching}>
        <List
          bordered
          dataSource={data}
          renderItem={(item, key) => (
            <List.Item
              key={key}
              className={item.isSection && "background-section"}
            >
              {item.isSection ? (
                <Row className="opencheck-list-page-list-item">
                  <Col span={24} className="opencheck-list-page-title">
                    <div className="opencheck-list-page-title-description">
                      <div
                        className="compliance-checklist-content"
                        dangerouslySetInnerHTML={{
                          __html:
                            item[`title_${curLanguage}`] || item[`title_en`],
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <>
                  <Row className="opencheck-list-page-list-item">
                    <Col span={20} className="opencheck-list-page-title">
                      <div className="opencheck-list-page-title-label">
                        <div
                          className="compliance-checklist-content"
                          dangerouslySetInnerHTML={{
                            __html:
                              item[`title_${curLanguage}`] || item[`title_en`],
                          }}
                        ></div>
                      </div>
                      <ChecklistTaskNote
                        comment={item.comment}
                        language={curLanguage}
                      />
                      <div className="opencheck-list-page-title-description">
                        {item.isInput && (
                          <div style={{ padding: "5px 10px" }}>
                            <Input
                              defaultValue={
                                item[`content_${curLanguage}`] ||
                                item[`content_en`]
                              }
                              style={{
                                background: "transparent",
                                maxWidth: "500px",
                              }}
                              onChange={(c) =>
                                setContents((e) => ({
                                  ...e,
                                  [item._id]: c.target.value,
                                }))
                              }
                            />
                          </div>
                        )}
                        {item.isDateRecord && (
                          <div style={{ padding: "0 10px" }}>
                            *RECORD TIME AND DATE AUTOMATICALLY*
                          </div>
                        )}
                        {item.isTemperature && (
                          <>
                            <div style={{ padding: "0 10px" }}>
                              *RECORD FRIDGE TEMPERATURES AUTOMATICALLY*
                            </div>
                          </>
                        )}
                        {item.isTempSlider && (
                          <>
                            <div
                              style={{
                                fontSize: "1.5rem",
                                textAlign: "center",
                                marginTop: 10,
                                fontWeight: "bold",
                              }}
                            >
                              {checkTempSlider[item._id] != null
                                ? Number(checkTempSlider[item._id]).toFixed(1)
                                : Number(item.tempSlider ?? 0).toFixed(1)}
                              °C
                            </div>
                            <Slider
                              className="temp-slider-width"
                              min={-30}
                              max={120}
                              step={0.1}
                              onChange={(temp) =>
                                setCheckTempSlider((e) => ({
                                  ...e,
                                  [item._id]: temp,
                                }))
                              }
                              value={
                                checkTempSlider[item._id] ??
                                item.tempSlider ??
                                0
                              }
                            />
                          </>
                        )}
                      </div>
                    </Col>
                    <Col span={2} className="opencheck-list-page-complete">
                      {item.status === "completed" ? (
                        <CheckOutlined
                          className="checklist-complete"
                          onClick={() => {
                            if (hotholdChecklistStatusData.completed) {
                              toast.error(
                                "You cannot change the status of a completed checklist."
                              );
                              return;
                            }
                            handleCompleteChecklist({
                              id: item._id,
                              data: {
                                status: "pending",
                                content:
                                  contents[item._id] ??
                                  (item[`content_${curLanguage}`] ||
                                    item[`content_en`]),
                                tempSlider:
                                  checkTempSlider[item._id] ?? item.tempSlider,
                              },
                            });
                          }}
                        />
                      ) : item.comment !== "" ? (
                        <SwapOutlined
                          className="checklist-complete"
                          onClick={() => {
                            if (hotholdChecklistStatusData.completed) {
                              toast.error(
                                "You cannot change the status of a completed checklist."
                              );
                              return;
                            }
                            handleCompleteChecklist({
                              id: item._id,
                              data: {
                                comment: "",
                                content:
                                  contents[item._id] ??
                                  (item[`content_${curLanguage}`] ||
                                    item[`content_en`]),
                                tempSlider:
                                  checkTempSlider[item._id] ?? item.tempSlider,
                              },
                            });
                          }}
                        />
                      ) : (
                        <CheckOutlined
                          className="checklist-pending"
                          onClick={() => {
                            if (hotholdChecklistStatusData.completed) {
                              toast.error(
                                "You cannot change the status of a completed checklist."
                              );
                              return;
                            }

                            // if it’s an input field, ensure there’s some content
                            if (item.isInput) {
                              const userContent = contents[item._id]?.trim();
                              const existingContent = (
                                (item[`content_${curLanguage}`] ||
                                  item[`content_en`]) ??
                                ""
                              ).trim();
                              if (!userContent && !existingContent) {
                                toast.error(
                                  "Please enter content before completing."
                                );
                                return;
                              }
                            }

                            handleCompleteChecklist({
                              id: item._id,
                              data: {
                                status: "completed",
                                content:
                                  contents[item._id] ??
                                  (item[`content_${curLanguage}`] ||
                                    item[`content_en`]),
                                tempSlider:
                                  checkTempSlider[item._id] ?? item.tempSlider,
                              },
                            });
                          }}
                        />
                      )}
                    </Col>
                    <Col span={2} className="opencheck-list-page-tools">
                      <Popover
                        placement="bottom"
                        content={
                          <div className="opencheck-list-page-tools-popover">
                            <Button
                              color="cyan"
                              variant="solid"
                              style={{ background: "rgb(47, 45, 113)" }}
                              onClick={() => {
                                handleReorderTask(item, "up");
                                setOpenPopoverId(null);
                              }}
                            >
                              {t("MoveUp")}
                            </Button>
                            <Button
                              color="cyan"
                              variant="solid"
                              style={{ background: "rgb(47, 45, 113)" }}
                              onClick={() => {
                                handleReorderTask(item, "down");
                                setOpenPopoverId(null);
                              }}
                            >
                              {t("MoveDown")}
                            </Button>
                            {item.comment === "" && (
                              <Button
                                color="green"
                                variant="solid"
                                icon={<EditOutlined />}
                                onClick={() =>
                                  navigate(`/provechecks/edit/${item._id}`)
                                }
                                size="small"
                              >
                                {t("Edit")}
                              </Button>
                            )}
                            <Button
                              variant="solid"
                              color="danger"
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => {
                                handleDeleteChecklist(item._id);
                                setOpenPopoverId(null);
                              }}
                              loading={isDeleteLoading}
                            >
                              {t("DELETE")}
                            </Button>
                            {item.status !== "completed" &&
                              item.comment === "" && (
                                <Button
                                  variant="solid"
                                  color="pink"
                                  size="small"
                                  icon={<FormOutlined />}
                                  onClick={() => {
                                    setIsModalOpen(true);
                                    setIsModalId(item._id);
                                    setOpenPopoverId(null);
                                  }}
                                >
                                  {t("Add Note")}
                                </Button>
                              )}
                          </div>
                        }
                        open={openPopoverId === item._id}
                        onOpenChange={(visible) =>
                          setOpenPopoverId(visible ? item._id : null)
                        }
                        trigger="click"
                      >
                        <MoreOutlined className="opencheck-list-page-tools-icon" />
                      </Popover>
                    </Col>
                  </Row>
                  {item.isTemperature &&
                    sensorlist?.data.map((itemTemp, key) => (
                      <div
                        key={key}
                        className="opencheck-list-page-temperature"
                      >
                        {itemTemp?.sensor_id} - {sensorTemps[itemTemp.dev_eui]}{" "}
                        °C
                      </div>
                    ))}
                </>
              )}
            </List.Item>
          )}
        />
        <Flex justify="center" style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            disabled={
              data.filter((item) => !item.isSection).length ===
              data.filter(
                (item) =>
                  !item.isSection &&
                  (item.status === "completed" || item.comment !== "")
              ).length
                ? false
                : true
            }
            onClick={() => {
              if (
                data.filter((item) => !item.isSection).length ===
                data.filter(
                  (item) =>
                    !item.isSection &&
                    (item.status === "completed" || item.comment !== "")
                ).length
              ) {
                updateOpenChecklistStatus({ completed: true });
                navigate("/home");
              }
            }}
          >
            {t("Submit")}
          </Button>
        </Flex>
        <Modal
          title="Reason"
          open={isModalOpen}
          onOk={() => {
            if (modalContent && modalContent !== "") {
              handleCompleteChecklist({
                id: isModalId,
                data: {
                  comment: modalContent,
                  ...(checkTempSlider[isModalId] != null && {
                    tempSlider: checkTempSlider[isModalId],
                  }),
                },
              });
              setIsModalOpen(false);
            } else {
              navigate("/home");
            }
          }}
          onCancel={() => setIsModalOpen(false)}
        >
          <Input.TextArea
            onChange={(e) => setModalContent(e.target.value)}
            value={modalContent}
            autoSave={{ min: 3, max: 3 }}
          />
        </Modal>
      </Spin>
    </Card>
  );
};

export default Hotholdchecklist;
